// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/UpdatesPage/UpdatesPage.css
// module id = 950
// module chunks = 0